export default __webpack_public_path__ + "static/media/Modelo 8.af5342c5.png";